import axios from "axios";
import config from "./config";

// Determine backend URL based on environment
const getBackendURL = () => {
  if (config.env === "production") {
    return "https://api.modlinedesign.com";
  }
  // Check if running on localhost
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return "http://localhost:9000";
  }
  // Default to the development server
  return "http://38.70.252.248:9000";
};

export default axios.create({
  baseURL: getBackendURL(),
  // headers: {'Authorization': `Bearer ${ID_TOKEN}`}
});
